import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SketchPicker, SwatchesPicker } from 'react-color';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { getPresetColors, addPresetColors, setPresetColors } from './ColorPickerPresets';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);
    const {defaultValue} = this.props;

    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onCancel = this.onCancel.bind(this);

    const presetColors = getPresetColors(props.templateId);
    if (props.presetColors && !presetColors.length) {
      setPresetColors(props.templateId, props.presetColors);
    }
    this.state = {
      color: {rgb: defaultValue},
      presetColors: presetColors
    };
  }

  onChange(color) {
    const { onChange } = this.props;
    this.setState({
      color: color
    });
    if (onChange) {
      onChange(color);
    }
  }

  onSelect() {
    const { templateId, onSelect } = this.props;
    const { color } = this.state;
    addPresetColors(templateId, color);
    if (onSelect) {
      onSelect(color);
    }
  }

  onCancel() {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  render() {
    const { color, presetColors } = this.state;
    const {swatchPickerHeight, swatchPickerWidth, sketchPickerWidth} = this.props;
    return (
      <div>
        <div style={{display: 'flex'}}>
          <div style={{overflow: 'hidden', height: swatchPickerHeight - 10}}>
            <SketchPicker
              onChange={this.onChange}
              color={color.rgb}
              presetColors={presetColors}
              width={sketchPickerWidth}
            />
          </div>
          {this.props.showSwatchesPicker &&
            <div style={{overflow: 'hidden'}}>
              <SwatchesPicker
                onChange={this.onChange}
                color={color.rgb}
                width={swatchPickerWidth}
                height={swatchPickerHeight}
              />
            </div>
          }
        </div>
        <RaisedButton
          label={this.props.confirmButtonLabel}
          style={this.props.confirmButtonLabelStyle}
          onClick={this.onSelect}
        />
        <FlatButton
          label={this.props.cancelButtonLabel}
          style={this.props.cancelButtonLabelStyle}
          onClick={this.onCancel}
        />
      </div>
    );
  }
}

ColorPicker.propTypes = {
  templateId: PropTypes.number,
  sketchPickerWidth: PropTypes.number,
  swatchPickerWidth: PropTypes.number,
  swatchPickerHeight: PropTypes.number,
  showSwatchesPicker: PropTypes.bool,
  cancelButtonLabel: PropTypes.string,
  cancelButtonLabelStyle: PropTypes.object,
  confirmButtonLabel: PropTypes.string,
  confirmButtonLabelStyle: PropTypes.object,
  defaultValue: PropTypes.string,
};

ColorPicker.defaultProps = {
  templateId: 0,
  sketchPickerWidth: 250,
  swatchPickerWidth: 250,
  swatchPickerHeight: 320,
  showSwatchesPicker: true,
  cancelButtonLabel: 'cancel',
  cancelButtonLabelStyle: {float: 'right', margin: 10},
  confirmButtonLabel: 'ok',
  confirmButtonLabelStyle: {float: 'right', margin: 10}
};